// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-container {
  max-width: 800px;
  margin: 1rem auto;
  padding: 1rem;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.upload-container h2 {
  color: #2c3e50;
  margin-bottom: 0.5rem;
  text-align: center;
}

.instruction {
  color: #7f8c8d;
  text-align: center;
  margin-bottom: 1rem;
}

.type-selector {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
}

.type-btn {
  padding: 1rem;
  background: #ecf0f1;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  color: #34495e;
  transition: all 0.2s;
  text-align: center;
}



.type-btn.active {
  background: #3498db;
  color: white;
}

.type-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.type-info {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 6px;
  margin-bottom: 1rem;
}

.type-info h3 {
  margin: 0 0 0.5rem 0;
  color: #2c3e50;
}

.type-info p {
  margin: 0;
  color: #7f8c8d;
}

.dropzone {
  border: 2px dashed #bdc3c7;
  border-radius: 6px;
  padding: 3rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  margin-bottom: 1rem;
}

.dropzone.active {
  border-color: #3498db;
  background-color: #f0f8ff;
}

.dropzone.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #f5f5f5;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.upload-icon {
  color: #7f8c8d;
}

.dropzone p {
  margin: 0;
  color: #34495e;
  font-size: 1rem;
}

.dropzone small {
  color: #95a5a6;
  font-size: 0.9rem;
}

.file-preview {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 1rem;
  background: #f8f9fa;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.file-icon {
  font-size: 2rem;
  color: #3498db;
}

.filename {
  margin: 0;
  font-weight: 600;
  color: #2c3e50;
}

.file-meta {
  margin: 0.2rem 0 0 0;
  font-size: 0.9rem;
  color: #7f8c8d;
}

.remove-btn {
  margin-left: auto;
  background: none;
  border: none;
  color: #e74c3c;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 0.5rem;
  border-radius: 50%;
  transition: all 0.2s;
}



.remove-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.upload-progress {
  margin-bottom: 1.5rem;
}

.progress-container {
  height: 10px;
  background: #ecf0f1;
  border-radius: 5px;
  margin-bottom: 0.5rem;
  position: relative;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: #3498db;
  border-radius: 5px;
  transition: width 0.3s ease;
}

.progress-text {
  display: block;
  text-align: center;
  font-size: 0.8rem;
  color: #7f8c8d;
}

.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(52, 152, 219, 0.2);
  border-top-color: #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.upload-btn {
  width: 100%;
  padding: 1rem;
  background: #27ae60;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.2s;
}

.upload-btn:hover {
  background: #219955;
}

.upload-btn:disabled {
  background: #bdc3c7;
  cursor: not-allowed;
}

.btn-icon {
  font-size: 1.2rem;
}

.alert-message {
  padding: 1rem;
  border-radius: 6px;
  margin: 1rem 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.alert-content {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.alert-message h4 {
  margin: 0 0 0.3rem 0;
}

.alert-message p {
  margin: 0;
  font-size: 0.9rem;
}

.alert-message.info {
  background: #e8f4fd;
  color: #2980b9;
}

.alert-message.error {
  background: #fdecea;
  color: #c0392b;
}

.alert-message.success {
  background: #e8f8ef;
  color: #27ae60;
}

.alert-close {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 0.2rem;
  margin-left: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Upload.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,4DAA4D;AAC9D;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;;;AAIA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;;;AAIA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".upload-container {\n  max-width: 800px;\n  margin: 1rem auto;\n  padding: 1rem;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.upload-container h2 {\n  color: #2c3e50;\n  margin-bottom: 0.5rem;\n  text-align: center;\n}\n\n.instruction {\n  color: #7f8c8d;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.type-selector {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.type-btn {\n  padding: 1rem;\n  background: #ecf0f1;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  color: #34495e;\n  transition: all 0.2s;\n  text-align: center;\n}\n\n\n\n.type-btn.active {\n  background: #3498db;\n  color: white;\n}\n\n.type-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.type-info {\n  background: #f8f9fa;\n  padding: 1rem;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n}\n\n.type-info h3 {\n  margin: 0 0 0.5rem 0;\n  color: #2c3e50;\n}\n\n.type-info p {\n  margin: 0;\n  color: #7f8c8d;\n}\n\n.dropzone {\n  border: 2px dashed #bdc3c7;\n  border-radius: 6px;\n  padding: 3rem;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s;\n  margin-bottom: 1rem;\n}\n\n.dropzone.active {\n  border-color: #3498db;\n  background-color: #f0f8ff;\n}\n\n.dropzone.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: #f5f5f5;\n}\n\n.upload-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.upload-icon {\n  color: #7f8c8d;\n}\n\n.dropzone p {\n  margin: 0;\n  color: #34495e;\n  font-size: 1rem;\n}\n\n.dropzone small {\n  color: #95a5a6;\n  font-size: 0.9rem;\n}\n\n.file-preview {\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 1rem;\n  background: #f8f9fa;\n}\n\n.file-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.file-icon {\n  font-size: 2rem;\n  color: #3498db;\n}\n\n.filename {\n  margin: 0;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.file-meta {\n  margin: 0.2rem 0 0 0;\n  font-size: 0.9rem;\n  color: #7f8c8d;\n}\n\n.remove-btn {\n  margin-left: auto;\n  background: none;\n  border: none;\n  color: #e74c3c;\n  cursor: pointer;\n  font-size: 1.2rem;\n  padding: 0.5rem;\n  border-radius: 50%;\n  transition: all 0.2s;\n}\n\n\n\n.remove-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.upload-progress {\n  margin-bottom: 1.5rem;\n}\n\n.progress-container {\n  height: 10px;\n  background: #ecf0f1;\n  border-radius: 5px;\n  margin-bottom: 0.5rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.progress-bar {\n  height: 100%;\n  background: #3498db;\n  border-radius: 5px;\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  display: block;\n  text-align: center;\n  font-size: 0.8rem;\n  color: #7f8c8d;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 3px solid rgba(52, 152, 219, 0.2);\n  border-top-color: #3498db;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.upload-btn {\n  width: 100%;\n  padding: 1rem;\n  background: #27ae60;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  transition: all 0.2s;\n}\n\n.upload-btn:hover {\n  background: #219955;\n}\n\n.upload-btn:disabled {\n  background: #bdc3c7;\n  cursor: not-allowed;\n}\n\n.btn-icon {\n  font-size: 1.2rem;\n}\n\n.alert-message {\n  padding: 1rem;\n  border-radius: 6px;\n  margin: 1rem 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.alert-content {\n  display: flex;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.alert-message h4 {\n  margin: 0 0 0.3rem 0;\n}\n\n.alert-message p {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.alert-message.info {\n  background: #e8f4fd;\n  color: #2980b9;\n}\n\n.alert-message.error {\n  background: #fdecea;\n  color: #c0392b;\n}\n\n.alert-message.success {\n  background: #e8f8ef;\n  color: #27ae60;\n}\n\n.alert-close {\n  background: none;\n  border: none;\n  color: inherit;\n  cursor: pointer;\n  padding: 0.2rem;\n  margin-left: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
